import { styles } from './template.scss';
import { FontSizes, FontWeights, LabelWidthValues } from '../../../../types/common/types';
import { InputWidthValues } from '../../../../ui/gzInput';

export const templatePackageSecurityServerAssignmentGrid = document.createElement('template');

templatePackageSecurityServerAssignmentGrid.innerHTML = `
  <style>${styles}</style>
  <div class='wrapper'>
    <gz-title fontSize='${FontSizes.PARAGRAPH_11}' fontWeight='${FontWeights.SEMIBOLD}' class='form-subtitle-info' id='security-server-assignment-subtitle'></gz-title>

    <gz-grid-view id='security-server-assignment' showGlobalActions>
      <div slot='grid-header-actions-slot' class='SVA-patch'>
        <div id='search-SVA-label'></div>
        <div id='search-SVA-boxes'>
          <div><gz-dropdown combobox id='search-SVA-input' labelWidth='${LabelWidthValues.LARGE}'></gz-dropdown></div>
          <div><gz-form-field id='custom-SVA-field' class='' label=''>
            <gz-input id='custom-SVA-input' gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
            <gz-input-error inputWidth='${InputWidthValues.LARGE}'></gz-input-error>
          </gz-form-field></div>
          <div><gz-icon-button id='add-SVA-button' disabled size='${FontSizes.HEADING_2}' fontSize='${FontSizes.BODY}' buttonType='square' icon='ds-icon-add' buttonFill='primary'></gz-icon-button></div>
        </div>
      </div>
      <div slot='no-results--additional-data' id='no-results-subtitle'></div>
    </gz-grid-view>
    <gz-form-field id='security-server-assignment-form-field-validation' class='hidden label-mw-250' label=''>
      <gz-dropdown gz-form-input localFiltering type='dropdown'></gz-dropdown>
    </gz-form-field>
    <gz-info-box id='SVA-grid-box-info' class='box-info' severity='warning'></gz-info-box>
    <gz-form-field id='use-SSL' class='flex-group'>
      <gz-checkbox class='use-SSL-field-input' gz-form-input></gz-checkbox>
    </gz-form-field>
  </div>
`;
